import { useEffect, useState } from "react";
import { Modal } from 'react-bootstrap-v5';

/*Tradução */
import '../../../i18n/config';
import { useTranslation } from 'react-i18next';

interface Props {
    // Chave completa, presente só enquanto o modal está aberto. Nunca persistir.
    chave: string | null;
    nome?: string;
    onFechar: () => void;
    // DEVN3-631: o mesmo modal mostra o segredo do webhook; os textos padrão são os da API Key.
    titulo?: string;
    rotulo?: string;
    instrucao?: string;
    aviso?: string;
    confirmacao?: string;
}

/**
 * DEVN3-627: única exibição da chave completa. Não fecha por clique fora nem por Esc, e o botão
 * de fechar só libera depois de marcar "Copiei a chave" — fechou, a chave não tem como ser
 * recuperada (o backend guarda só o hash).
 */
export default function ApiKeyModalChave({
    chave, nome, onFechar,
    titulo = 'API Key criada',
    rotulo = 'Chave',
    instrucao = 'Copie a chave agora.',
    aviso = 'Ela não será exibida novamente. Se for perdida, será preciso gerar uma nova chave e revogar esta.',
    confirmacao = 'Copiei a chave e guardei em local seguro.'
}: Props) {
    const { t } = useTranslation();
    const [copiada, setCopiada] = useState<boolean>(false);
    const [confirmou, setConfirmou] = useState<boolean>(false);

    useEffect(() => {
        setCopiada(false);
        setConfirmou(false);
    }, [chave]);

    async function copiar() {
        if (!chave) return;

        try {
            await navigator.clipboard.writeText(chave);
            setCopiada(true);
        } catch {
            // Sem permissão de clipboard (ex.: http fora de localhost): o campo já fica selecionável.
            setCopiada(false);
        }
    }

    return <Modal size='lg' centered={true} show={!!chave} backdrop="static" keyboard={false} onHide={() => { }}>
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title titulo-modal">{t(titulo)}{nome ? ` — ${nome}` : ''}</h5>
            </div>
            <div className="modal-body">
                <div className="alert alert-warning d-flex align-items-center" role="alert">
                    <i className="bi bi-exclamation-triangle fs-2 me-3"></i>
                    <div>
                        <strong>{t(instrucao)}</strong>{' '}
                        {t(aviso)}
                    </div>
                </div>

                <label htmlFor="api-key-chave" className="form-label">{t(rotulo)}</label>
                <div className="input-group">
                    <input id="api-key-chave" type="text" readOnly className="form-control" style={{ fontFamily: 'monospace' }}
                        value={chave ?? ''} onFocus={(e) => e.target.select()} autoComplete="off" />
                    <button type="button" className="btn btn-sm btn-primario" onClick={copiar}>
                        <i className={`text-white ${copiada ? 'fas fa-check' : 'far fa-copy'}`}></i>
                        <span style={{ verticalAlign: 'middle' }}> {copiada ? t('Copiada') : t('Copiar')} </span>
                    </button>
                </div>

                <div className="form-check mt-5">
                    <input id="api-key-confirmou" type="checkbox" className="form-check-input" checked={confirmou}
                        onChange={(e) => setConfirmou(e.target.checked)} />
                    <label htmlFor="api-key-confirmou" className="form-check-label">
                        {t(confirmacao)}
                    </label>
                </div>
            </div>
            <div className="modal-footer" style={{ margin: '0 auto' }}>
                <button disabled={!confirmou} onClick={onFechar} type="button" className="btn btn-primario"> {t('FECHAR')} </button>
            </div>
        </div>
    </Modal>;
}
